import gql from 'graphql-tag';

import { createUseQuery } from 'app/graphql/apolloFactoryHelpers';
import {
  GetBattlecardAccountFilters,
  GetBattlecardAccountFiltersVariables
} from 'app/graphql/generated/graphqlApolloTypes';

export const GET_BATTLECARD_ACCOUNT_FILTERS = gql`
  query GetBattlecardAccountFilters($battlecardId: Int!, $deploymentModelId: Int!) {
    getDeploymentModelSpec(input: { battlecardId: $battlecardId, deploymentModelId: $deploymentModelId }) {
      battlecards {
        battlecardId
        accountSourceFilter
        accountAttributeFilter
      }
    }
  }
`;

export const useGetBattlecardAccountFilters = createUseQuery<
  GetBattlecardAccountFilters,
  GetBattlecardAccountFiltersVariables
>(GET_BATTLECARD_ACCOUNT_FILTERS);
